/** The Wait element: pauses the run for a duration. */
import { MetadataEntityFieldType } from '../../../metadata/entity/decorators/model/metadata.entity.field.types';
import { WorkflowStepType } from '../workflow.definition';
import { WorkflowElement, WorkflowFamily, WorkflowFieldRenderer, WorkflowSideEffect } from '../workflow.element';

/** Pauses the run for `duration`, then continues against the Job as it is then. */
export const WAIT_ELEMENT: WorkflowElement = {
    type: WorkflowStepType.Wait,
    family: WorkflowFamily.Flow,
    sideEffect: WorkflowSideEffect.Time,
    title: 'Wait',
    icon: 'fa-hourglass-half',
    fields: [
        {
            bind: 'duration',
            required: true,
            renderer: WorkflowFieldRenderer.Duration,
            bindable: false,
            metadata: {
                displayName: 'Wait for',
                type: MetadataEntityFieldType.String,
            },
        },
    ],
    outputs: [],
};
